import { GridInput } from '@it2go/data-grid';
import { Injectable } from '@angular/core';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    EducationGridObject,
    EducationObject,
} from '@libs/types/src/services/object-type/education.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from './types/filter.types';
import { educationFrag } from './types/education.types';

@Injectable({ providedIn: 'root' })
export class EducationGqlService extends GqlServiceV2 {
    public getEducation(input: IdInput, fragment: string = educationFrag) {
        return this.query<EducationObject>(
            `
                query($input: IdInput!) {
                    education {
                        get(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getEducations(
        input: GridInput | null = null,
        fragment: string = educationFrag,
    ) {
        return this.query<EducationGridObject>(
            `
                query($input: GridInput) {
                    education {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
